import React from 'react'
// images ------
import Avatar from "../../assets/Images/user-avatar.jpg"
import LivePreviewImg from "../../assets/Images/notification/live-preview.png"
// icons ----------------------
import { FaThumbsUp } from "react-icons/fa6";
import { AiFillDislike } from "react-icons/ai";
import { BsChatFill } from "react-icons/bs";
import { TbArrowForwardUp } from "react-icons/tb";
import { FaShare } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import { FiMonitor } from "react-icons/fi";
import { HiDeviceMobile } from "react-icons/hi";

const LivePreview = ({
    icon,
    annTypeData,
    subject,
    anntypeDes,
    selectedTagEmp,
    banner,
    reactionAllowId,
    reactionDislikeId,
    commentId,
    repliesId,
    approveComments,
    width = "100%",
    height = `auto`
}) => {

    return (
        <div className='noti-widget-bg' style={{ width: width, height: height }}>
            <h3 className='color-white mb-2'>Live Preview</h3>
            <div className='lp-ann-pre'>
                <div className='lp-ann-pre-hed'>
                    <div className='left-hed'>
                        <img src={Avatar} alt='' className='left-head-profile' />
                        <div className='profile-content'>
                            <h5 className='color-white'>Sharah Johnsan</h5>
                            <span className='color-white'>2 minuts ago</span>
                        </div>
                    </div>
                    <div className='right-hed'>
                        {icon ? <img src={icon} className="live-preview-img" /> : null}
                    </div>
                </div>
                <div className='lp-ann-pre-content mt-3'>
                    <h3 className='color-white mb-2'>{subject}</h3>
                    <p className='color-gray mb-3' dangerouslySetInnerHTML={{ __html: anntypeDes }}>
                    </p>
                    {
                        banner ? <img src={banner} alt='Live Preview Img' /> : null
                    }
                </div>
                <div className='tagged mt-2'>
                    {
                        selectedTagEmp.length > 0 ? <div className='tagged-head'><span>@</span>Tagged:</div> : null
                    }
                    <div className='tagged-content mt-1'>
                        {
                            selectedTagEmp.map((item) => {
                                return <span className='color-white' key={item.value}>
                                    <img src={Avatar} />
                                    {item.label}
                                </span>
                            })
                        }
                    </div>
                </div>

                <hr className='color-white' />

                <div className='lp-pre-footer'>
                    <div className='footer-left'>
                        {
                            reactionAllowId == "1" ? <span className='like'><FaThumbsUp className='f-icon' /> <span>0</span> </span> : null
                        }
                        {
                            reactionDislikeId == "1" ? <span className='dislike'><AiFillDislike className='f-icon' /> <span>0</span> </span> : null
                        }
                        {
                            commentId == "1" ? <span className='chat'><BsChatFill className='f-icon' /> <span>0</span> </span> : null
                        }
                        {
                            repliesId == "1" ? <span className='back-arrow'><FaShare className='f-icon' /> <span>0</span> </span> : null
                        }
                    </div>
                    <div className='footer-right'>
                        <span className='eye'><FaEye className='f-icon' /> <span>24 Views</span></span>
                    </div>
                </div>
            </div>

            <div className='lp-ann-pre-footer mt-3'>
                <div className='top-content color-white'>
                    <span>Preview Theme</span>
                    <select>
                        <option>Festival (Orange)</option>
                    </select>
                </div>
                <div className='bottom-content mt-3 color-white'>
                    <span>Device View</span>
                    <div className='device-container'>
                        <span className='color-white active'> <FiMonitor className='device-icon active' /> </span>
                        <span className='color-white'> <HiDeviceMobile className='device-icon' /> </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LivePreview